<template>
  <div>
    <common-dialog
      ref="dialog"
      width="700px"
      :show-save-button="$permission.canEdit()"
      unit="友情链接"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="125px"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      :get-data-func="api.info"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="链接名称" prop="LinkName">
              <el-input
                v-model="data.LinkName"
                placeholder="请填写链接名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="链接类型" prop="LinkType">
              <el-select
                v-model="data.LinkType"
                placeholder="请选择链接类型"
                clearable
              >
                <el-option label="小程序" :value="1"></el-option>
                <el-option label="公众号" :value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="图片" prop="LinkPhoto">
              <single-pic-upload
                v-model="data.LinkPhoto"
                type="LinkPhoto"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
              <span style="color: red">最佳宽高比例3:2</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            :span="24"
            v-if="data.LinkType == 2"            
          >
            <el-form-item label="公众号二维码" prop="QrCode" :rules="data.LinkType == 2 ? qrRules.QrCode : null">
              <single-pic-upload
                v-model="data.QrCode"
                type="QrCode"
                :uploadUrl="uploadUrl"
              ></single-pic-upload>
            </el-form-item>
          </el-col>
          <el-col
            :span="isMB ? 24 : 12"
            v-if="data.LinkType == 1"          
          >
            <el-form-item label="小程序Id" prop="LinkAppid"  :rules="data.LinkType == 1 ? appRules.LinkAppid : null">
              <el-input v-model="data.LinkAppid" type="text" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="序号" prop="OrderId">
              <el-input-number v-model="data.OrderId" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="isMB ? 24 : 12">
            <el-form-item label="状态" prop="State">
              <el-radio-group v-model="data.State">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
      <template #footer v-if="!$permission.canEdit()">
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
    <goods-dialog
      ref="goodsDialog"
      in-dialog
      selectable
      :multiple="false"
      @select="setGoods"
    />
  </div>
</template>
  <script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
import singlePicUpload from "@/components/common/photo/singleUpload";
import businessSelect from "@/components/shop/business/select";
import treeSelect from "@/components/common/treeSelect";
import goodsDialog from "@/components/goods/info/listDialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    singlePicUpload,
    businessSelect,
    treeSelect,
    goodsDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        LinkType: 1,
        LinkName: "",
        LinkPhoto: "",
        OrderId: 0,
        State: 1,
        LinkAppid: "",
        QrCode: "",
      },

      api: require("@/api/store/links").default,
      api2: require("@/api/goods/type").default,

      isMB: this.$store.state.isMB,
      rules: {
        LinkName: [{ required: true, message: "链接名称不能为空" }],
        LinkPhoto: [{ required: true, message: "图片不能为空" }],

        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      appRules: {
        LinkAppid: [{ required: true, message: "小程序id不能为空" }],
      },
      qrRules: {
        QrCode: [{ required: true, message: "公众号二维码图片不能为空" }],
      },
      uploadUrl: "/api/Common/UploadPicture",
      loginInfo: JSON.parse(localStorage.getItem("loginInfo")),
      TypePlatforms: [],
      props: {
        value: "RecordId",
        label: "TypeName",
        children: "children",
      },
    };
  },

  // watch: {
  //   //监听
  //   "data.StoreId": {
  //     //监听AdType的值，
  //     handler(val,oldVal) {
  //       if (val) {
  //         if(this.data.RecordId>0){

  //         }else{
  //           this.data.GoodsTypeId=null;
  //         }
  //         this.getOption()
  //       }
  //     },
  //   },
  // },
  methods: {
    getOption() {
      // var param = { State: 1 };
      // if (this.loginInfo.UserType == 0) {
      //   param.StoreId = this.data.StoreId;
      // }
      // this.api2.list(param).then((res) => {
      //   if (res.Code == 0) {
      //     this.TypePlatforms = this.$commonJs.toTreeData(
      //       res.Data,
      //       "RecordId",
      //       "TypeIdParent",
      //       "children"
      //     );
      //     if (this.$refs.treeSelect) {
      //       this.$refs.treeSelect.setData();
      //     }
      //   }
      // });
    },
    onGoodsDialog() {
      var param = { SaleState: 1 };
      if (this.loginInfo.UserType == 0) {
        param.StoreId = this.data.StoreId;
      }
      this.$refs.goodsDialog.open().then((that) => {
        that.getData(param);
        that.getTree();
      });
    },
    setGoods(t) {
      console.log(t, "setgoods");
      this.data.GoodsId = t.RecordId;
      this.data.GoodsName = t.GoodsName;
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.GoodsTypeName = "";
        this.data.GoodsTypeId = null;
      } else {
        this.data.GoodsTypeName = t.TypepName;
        this.data.GoodsTypeId = t.RecordId;
      }
    },
    onCreateOpened(row) {
      this.getOption();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    onEditOpened(row) {
      this.getOption();
    },
    onBeforeSave() {},
    onClosed() {},
  },
};
</script>